export enum GTMEvent {
    addToCart = 'add_to_cart',
    addToWishlist = 'add_to_wishlist',
    checkoutHasBegun = 'begin_checkout',
    consent = 'consent',
    login = 'login',
    purchase = 'purchase',
    removeItemFromCart = 'remove_from_cart',
    search = 'search',
    signUp = 'sign_up',
    viewCart = 'view_cart',
    viewItem = 'view_item',
    viewItemList = 'view_item_list',
}

export const ecommerceEvents: GTMEvent[] = [
    GTMEvent.addToCart,
    GTMEvent.checkoutHasBegun,
    GTMEvent.purchase,
    GTMEvent.removeItemFromCart,
    GTMEvent.viewCart,
    GTMEvent.viewItem,
    GTMEvent.viewItemList,
];
